export class ReviewListResponse {
    comment: string;
    createdDate: string;
    id: string;
    orderId: string;
    orderSlug: string;
    rating: number;
}